import { render, staticRenderFns } from "./external-answers_customers.vue?vue&type=template&id=797a9de2"
import script from "./external-answers_customers.vue?vue&type=script&lang=js"
export * from "./external-answers_customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports